import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField} from "@mui/material";
import {Box} from "@mui/system";
import {
    EquipmentRepairRequestStatusEnum,
    useEquipmentRepairRequestAddStatusMutation
} from "../../../../../../graphql/graphQlApiHooks";
import {LoadingButton} from "@mui/lab";

const FixedByOwnEffortsDialog = ({open, onClose, equipmentRepairRequestId}: {
    open: boolean,
    onClose: () => void,
    equipmentRepairRequestId: string
}) => {
    const [comment, setComment] = React.useState('');

    const [addStatus, {loading}] = useEquipmentRepairRequestAddStatusMutation()

    const submitHandler = () => {
        addStatus({
            variables: {
                equipmentRepairRequestId,
                state: {
                    status: EquipmentRepairRequestStatusEnum.FixedByOwnEfforts,
                    comment
                }
            }
        }).then(() => {
            onClose();
            setComment('')
        })
    };

    return (
        <Dialog
            open={open}
            onClose={() => {
                onClose();
                setComment('')
            }}
        >

            <DialogTitle>
                Устранено своими силами
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Укажите комментарий к заявке, если необходимо
                </DialogContentText>
                <Box
                    mt={2}
                >
                    <TextField
                        label="Комментарий"
                        multiline
                        rows={4}
                        variant="outlined"
                        fullWidth
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        size={'small'}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={() => {
                        onClose();
                        setComment('')
                    }}
                    size={'small'}
                >
                    Отмена
                </Button>
                <LoadingButton
                    variant={'contained'}
                    size={'small'}
                    onClick={submitHandler}
                    loading={loading}
                >
                    Устранено своими силами
                </LoadingButton>
            </DialogActions>

        </Dialog>
    );
};

export default FixedByOwnEffortsDialog;